// extracted by mini-css-extract-plugin
module.exports = {"mainLogo":"Logo_mainLogo__2ZrEE","logo":"Logo_logo__2pUYw","text":"Logo_text__xi_0f"};